module.exports = __webpack_public_path__ + "img/profile_white.65cc34a9.png";